import Vue from 'vue'
import Meta from 'vue-meta'
import VueProgressBar from 'vue-progressbar'
import VueStash from 'vue-stash'
import VueMoment from 'vue-moment'
import VueAnalytics from 'vue-analytics'
import Icon from 'vue-awesome/components/Icon'
import BootstrapVue from 'bootstrap-vue'
import AsyncComputed from 'vue-async-computed'
import VueClipboard from 'vue-clipboard2'
import * as log from 'loglevel'
import App from './App'
import router from './router'
import './directives/busy-button.directive'
import './filters/filename.filter'
import './filters/stalkerThreeLetterInitials.filter'
import './filters/channelType.filter'
import './filters/integrationType.filter'
import './filters/agent-state.rbm.filter'
import './filters/region.rbm.filter'
import progressConfig from './config/progress/progress.config'
import gaConfig from './config/google-analytics'
import moment from './config/moment'
import store from './config/store'
import bootstrapApp from './init/app-bootstrap'
import './scss/main.scss'
import 'flatpickr/dist/flatpickr.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'
import enums from './common/enums'
import Snotify from 'vue-snotify'
import 'vue-snotify/styles/material.css' // we also need to import the styles for webpack's css-loader
import snotifyConfig from './config/snotify'

Vue.prototype.$enums = enums

Vue.component('icon', Icon)
Vue.use(Meta)
Vue.use(AsyncComputed)
Vue.use(VueClipboard)
Vue.use(BootstrapVue)
Vue.use(VueProgressBar, progressConfig)
Vue.use(VueStash)
Vue.use(VueMoment, {moment})
Vue.use(VueAnalytics, gaConfig)
Vue.use(Snotify, {toast: snotifyConfig})

window.log = log.noConflict()
log.setLevel(process.env.VUE_APP_LOG_LEVEL)

Vue.config.productionTip = false
Vue.config.devtools = true

bootstrapApp()

new Vue({
  router,
  render: h => h(App),
  data: {store}
}).$mount('#app')
